<script setup lang="ts">
import IdentityForm from '@/components/IdentityForm.vue'
import MemberEmailForm from '@/components/MemberEmailForm.vue'

import { useCheckoutIdentity } from '@/composables/useCheckoutIdentity'

defineProps<{ disabled?: boolean }>()

const {
  identityFormRef,
  memberEmailFormRef,
  showIdentityForm,
  requireEmailForMember,
  getValidatedIdentity,
  resolveIdentityData,
} = useCheckoutIdentity()

defineExpose({ getValidatedIdentity, resolveIdentityData })
</script>

<template>
  <IdentityForm v-if="showIdentityForm" ref="identityFormRef" :disabled="disabled" />
  <MemberEmailForm v-else-if="requireEmailForMember" ref="memberEmailFormRef" :disabled="disabled" />
</template>
